module.exports = __webpack_public_path__ + "static/img/gazetaTopo1.e16e234.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens/TCE-AL/gazetaTopo1.png
// module id = qDLD
// module chunks = 1